import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export const SlidingModalUniDriver = (base: UniDriver, _: UniDriver) => {
  const isOpen = () => base.hasClass('cairo-sliding-modal-is-open');

  return {
    ...baseUniDriverFactory(base),
    isOpen,
  };
};
